import { BaseResource } from "./base.resource";

export const FacilityTypeAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class FacilityType extends BaseResource {
  active: boolean;
  name: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & FacilityTypeAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & FacilityTypeAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & FacilityTypeAccessLevel.Delete) > 0;
  }
}
